import type { WorkOrderPriceItem } from 'gql/graphql';

import type { ColDefField } from 'ag-grid-community/dist/types/core/entities/colDef';

export enum WorkOrderMenuActionTypes {
    addKC2 = 'addKC2',
    addMtr = 'addMtr',
    addCoefficient = 'addCoefficient',

    editUer = 'editUer',
    editNote = 'editNote',
    editCoefficient = 'editCoefficient',
    matchMtr = 'matchMtr',
    editMtr = 'editMtr',
    editOther = 'editOther',
    viewOther = 'viewOther',
    editOtherDistribution = 'editOtherDistribution',

    actsKc2Analytics = 'actsKc2Analytics',

    singleDelete = 'singleDelete',
}
type PartialWorkOrderPriceItem = Record<
    keyof Pick<WorkOrderPriceItem, 'chapter' | 'status' | 'code' | 'name' | 'unit' | 'workName' | 'workInSum'>,
    ColDefField<WorkOrderPriceItem>
>;
export const COLUMN_NAMES_WITH_FILTER: PartialWorkOrderPriceItem = {
    chapter: 'chapter',
    status: 'status',
    code: 'code',
    name: 'name',
    unit: 'unit',
    workName: 'workName',
    workInSum: 'workInSum',
};
